// src/api/dashboard.js
import axiosClient from "./axiosClient";

//Fetch properties accessible by the logged-in user
export const getAccessibleProperties = (liveFilter = null) => {
  const params = {};
  if (liveFilter !== null) {
    params.live = liveFilter;
  }
  return axiosClient.get("/properties/accessible/", { params });
};

// Fetch compliance stats (expired & expiring soon for insurance, utilities, assessments)
// Also includes total property and unit counts from database
export const getComplianceStats = async (liveFilter = null) => {
  const params = {};
  if (liveFilter !== null) {
    params.live = liveFilter;
  }
  const res = await axiosClient.get("/compliance/stats/", { params });
  return res.data;
};
